import {Component, Input, OnInit} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import { OrganisationService } from '../../services/organisation/organisation.service';
import {CreateReferenceSurveyComponent} from "../create-reference-survey/create-reference-survey.component";
import {ConstantsService} from "../../services/constants/constants.service";

@Component({
  selector: 'app-how-to-personalise-content-modal',
  templateUrl: './how-to-personalise-content-modal.component.pug',
  styleUrls: ['./how-to-personalise-content-modal.component.scss'],
  standalone: false
})
export class HowToPersonaliseContentModalComponent implements OnInit {
  currentOrg: any;
  @Input() questionnaireId:string = ''
  @Input() configureOptInOnly: boolean = false;
  @Input() isEditTitle: boolean = false;
  @Input() questionnaireTitle:string = ''
  @Input() selectedRefType:any
  @Input() max_questions_limit = 5;
  @Input() isOptInQuestionEnabled: boolean = true;
  @Input() optInQuestion: string = ConstantsService.DEFAULT_OPT_IN_QUESTION

  constructor(
      public _bsModalRef: BsModalRef,
      public modalService: BsModalService,
      public organisationService: OrganisationService,
  ) {
  }

  ngOnInit(): void {
    this.organisationService.getOrganisation().subscribe(res => {
      this.currentOrg = res;
    });
  }

  closePersonaliseModal(): void {
    this._bsModalRef.hide();
    const initialState = {
      'questionnaireId': this.questionnaireId,
      'questionnaireTitle': this.questionnaireTitle,
      'isEditTitle': this.isEditTitle,
      'configureOptInOnly': this.configureOptInOnly,
      'selectedRefType': this.selectedRefType,
      'max_questions_limit': this.max_questions_limit,
      'isOptInQuestionEnabled': this.isOptInQuestionEnabled,
      'optInQuestion': this.optInQuestion,
      'backFromHowToPersonaliseModal': true
    };
    this.modalService.show(
      CreateReferenceSurveyComponent,
      { class: 'modal-dialog-centered xl-popup', initialState},
    )
  }
}